module.exports = __webpack_public_path__ + "catalog/items/balcony/painted.jpg";